import * as React from "react";
const SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    width="90px"
    height="90px"
    {...props}
  >

    <path
      d="M 355.718 218.875 L 355.718 222.365 C 355.718 272.277 355.718 297.22 340.446 312.729 C 325.188 328.224 300.611 328.224 251.474 328.224 C 202.336 328.224 177.762 328.224 162.49 312.729 C 147.231 297.22 147.231 272.277 147.231 222.365 L 147.231 169.436 C 147.231 119.539 147.231 94.595 162.49 79.087 C 177.762 63.579 202.336 63.579 251.474 63.579 C 300.611 63.579 316.533 63.312 329.269 80.95"
      strokeLinecap="round"
      style={{
        stroke: "rgb(0, 0, 0)",
        strokeWidth: 15,
        fill: "rgb(91, 54, 193)",
      }}
    />
    <path
      d="M 272.568 135.115 C 272.568 149.736 260.893 161.578 246.507 161.578 C 232.108 161.578 220.446 149.736 220.446 135.115 C 220.446 120.506 232.108 108.649 246.507 108.649 C 260.893 108.649 272.568 120.506 272.568 135.115 Z"
      stroke="#1C274C"
      style={{
        fill: "rgb(255, 255, 255)",
        strokeWidth: 14,
      }}
    />
    <path
      d="M 306.089 246.87 C 306.089 276.512 281.221 300.538 250.542 300.538 C 219.862 300.538 194.997 276.512 194.997 246.87 C 194.997 217.247 219.862 193.204 250.542 193.204 C 281.221 193.204 306.089 217.247 306.089 246.87 Z"
      stroke="#1C274C"
      style={{
        strokeWidth: 14,
        fill: "rgb(255, 255, 255)",
      }}
    />
    <path
      d="M 395.607 101.42 L 395.607 147.574 M 364.147 116.805 L 364.147 147.574 M 332.689 132.188 L 332.689 147.574 M 434.954 124.497 C 434.954 162.727 403.268 193.725 364.173 193.725 C 348.16 193.725 293.399 193.725 293.399 193.725 C 293.399 193.725 305.66 164.926 300.752 155.265 C 296.042 145.996 293.39 135.55 293.39 124.497 C 293.39 86.259 325.084 55.267 364.173 55.267 C 403.268 55.267 434.954 86.259 434.954 124.497 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        strokeWidth: 10,
        stroke: "rgb(28, 39, 76)",
        fill: "rgb(166, 90, 240)",
      }}
    />
    <ellipse
      style={{
        fill: "rgb(28, 39, 76)",
        stroke: "rgb(91, 54, 193)",
      }}
      cx={251.018}
      cy={248.613}
      rx={20.301}
      ry={19.617}
    />
  </svg>
);
export default SVGComponent;
